module.exports = __webpack_public_path__ + "img/Vector (4).f41c3e81.svg";